<script>
import { api } from "@/state/services";
import { mapState } from "vuex";

// Linha de cartões de resumo: cada cartão carrega de forma independente
export default {
  data() {
    return {
      points: { loading: true, errored: false, summary: null },
      wallet: { loading: true, errored: false, balance: null },
      clients: { loading: true, errored: false, total: null },
      network: { loading: true, errored: false, total: null },
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    creci() {
      return this.account && this.account.user ? this.account.user.creci : "";
    },
  },
  methods: {
    // Executa a chamada e marca o bloco como carregado/erro sem quebrar a home
    load(block, url, onSuccess) {
      api
        .get(url)
        .then((response) => {
          if (response.data && response.data.status == "success") {
            onSuccess(response.data);
          } else if (response.data && response.data.status == "empty") {
            onSuccess({ total: 0, list: [] });
          } else {
            block.errored = true;
          }
        })
        .catch(() => {
          block.errored = true;
        })
        .finally(() => {
          block.loading = false;
        });
    },
    formatPoints(value) {
      return this.$options.filters.points(value || 0);
    },
  },
  mounted() {
    this.load(this.points, "points/summary", (data) => {
      this.points.summary = data.summary || null;
      this.points.errored = !data.summary;
    });
    this.load(this.wallet, "wallet/balance/network", (data) => {
      this.wallet.balance = this.$options.filters.currency(data.balance || 0);
    });
    this.load(this.clients, "clients", (data) => {
      this.clients.total = Number(data.total) || 0;
    });
    this.load(this.network, "network/sponsored", (data) => {
      this.network.total = Number(data.total) || 0;
    });
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12 col-sm-6 col-xl-3 d-flex">
      <router-link to="/points" class="card home-summary home-summary-featured w-100">
        <div class="card-body p-3">
          <p class="text-uppercase font-size-12 mb-1">Pontos disponíveis</p>
          <b-skeleton v-if="points.loading" width="60%" height="1.6rem"></b-skeleton>
          <template v-else-if="!points.errored && points.summary">
            <h4 class="mb-1 notranslate">{{ formatPoints(points.summary.available) }} pts</h4>
            <small class="d-block">
              Acumulado {{ formatPoints(points.summary.earned) }} · Utilizado {{ formatPoints(points.summary.spent) }}
            </small>
          </template>
          <h4 v-else class="mb-0">–</h4>
        </div>
      </router-link>
    </div>
    <div class="col-12 col-sm-6 col-xl-3 d-flex">
      <router-link to="/wallet/extract" class="card home-summary w-100">
        <div class="card-body p-3">
          <p class="text-muted text-uppercase font-size-12 mb-1">Saldo da carteira</p>
          <b-skeleton v-if="wallet.loading" width="60%" height="1.6rem"></b-skeleton>
          <h4 v-else class="mb-1 notranslate">{{ wallet.errored ? "–" : wallet.balance }}</h4>
          <small class="text-muted d-block">Ver extrato</small>
        </div>
      </router-link>
    </div>
    <div class="col-12 col-sm-6 col-xl-3 d-flex">
      <router-link to="/clients" class="card home-summary w-100">
        <div class="card-body p-3">
          <p class="text-muted text-uppercase font-size-12 mb-1">Clientes indicados</p>
          <b-skeleton v-if="clients.loading" width="40%" height="1.6rem"></b-skeleton>
          <h4 v-else class="mb-1">{{ clients.errored ? "–" : clients.total }}</h4>
          <small class="text-muted d-block">Ver todos</small>
        </div>
      </router-link>
    </div>
    <div class="col-12 col-sm-6 col-xl-3 d-flex">
      <router-link to="/network/sponsored" class="card home-summary w-100">
        <div class="card-body p-3">
          <p class="text-muted text-uppercase font-size-12 mb-1">Corretores na rede</p>
          <b-skeleton v-if="network.loading" width="40%" height="1.6rem"></b-skeleton>
          <h4 v-else class="mb-1">{{ network.errored ? "–" : network.total }}</h4>
          <small v-if="creci" class="text-muted d-block notranslate">Meu CRECI: {{ creci }}</small>
        </div>
      </router-link>
    </div>
  </div>
</template>

<style scoped>
.home-summary {
  color: inherit;
  text-decoration: none;
}

.home-summary-featured {
  color: #fff;
  background: linear-gradient(145deg, #9a2524, #721817);
}

.home-summary-featured h4 {
  color: #fff;
}
</style>
